$(window).scroll(function () {
    var header = $(".header");
    if ($(this).scrollTop() > 0) {
        $(header).addClass("js-sticky");
    } else {
        $(header).removeClass("js-sticky");
    }
});

var langCurrent = $(".lang-sel__current");
var langToggle = $(".lang-sel__toggle");

$(langCurrent).click(function () {
    $(langToggle).toggleClass("js-show");
    $(langCurrent).toggleClass("js-show");
});

var menuToggle = $(".m-toggle");
var menu = $(".menu");
var menuHamb = $(".m-hamb");

// Toggle menú móvil con cambio de icono Burger/X
$(menuToggle).on("click", function () {
    var $btn = $(this);
    $btn.toggleClass("js-open");
    menuHamb.toggleClass("js-open");
    var nowOpen = $btn.hasClass("js-open");
    $btn.attr("aria-expanded", nowOpen ? "true" : "false");
    $btn.find(".icon-burger").toggleClass("hidden", nowOpen);
    $btn.find(".icon-close")
        .toggleClass("hidden", !nowOpen)
        .toggleClass("flex", nowOpen);
    $("body").toggleClass("overflow-hidden", nowOpen); // evitar scroll detrás del menú
});

// Cerrar con tecla ESC
$(document).on("keyup", function (e) {
    if (e.key === "Escape") {
        var $btn = menuToggle;
        if ($btn.hasClass("js-open")) {
            $btn.removeClass("js-open").attr("aria-expanded", "false");
            menuHamb.removeClass("js-open");
            $btn.find(".icon-burger").removeClass("hidden");
            $btn.find(".icon-close").addClass("hidden").removeClass("flex");
            $("body").removeClass("overflow-hidden");
        }
    }
});

// Cerrar al hacer click en enlaces del menú móvil
$(document).on("click", "#closeMobileMenu", function () {
    var $btn = menuToggle;
    if ($btn.hasClass("js-open")) {
        $btn.removeClass("js-open").attr("aria-expanded", "false");
        menuHamb.removeClass("js-open");
        $btn.find(".icon-burger").removeClass("hidden");
        $btn.find(".icon-close").addClass("hidden").removeClass("flex");
        $("body").removeClass("overflow-hidden");
    }
});

// Cerrar al hacer click en enlaces del menú móvil
$(document).on("click", "#mobileMainMenu ", function () {
    var $btn = menuToggle;
    if ($btn.hasClass("js-open")) {
        $btn.trigger("click");
    }
});
